import React from 'react';
import { Library, MessageSquareText, Tags } from 'lucide-react';
import { AudienceLevel, ConversationRead } from '../../types/pathway';
import { NotesInput } from './NotesInput';
export type EntryMode = 'notes' | 'topics' | 'pathways';
interface StartPanelProps {
  mode: EntryMode;
  notes: string;
  topicsContent: React.ReactNode;
  pathwaysContent: React.ReactNode;
  audience: AudienceLevel | 'any';
  liveRead: ConversationRead;
  activeTerms: string[];
  suggestedTerms: string[];
  vocabulary: string[];
  detectedLevel: AudienceLevel | null;
  matchCount: number | null;
  hasSearch: boolean;
  onReset: () => void;
  onModeChange: (mode: EntryMode) => void;
  onNotesChange: (value: string) => void;
  onAudienceChange: (value: AudienceLevel | 'any') => void;
  onToggleTerm: (term: string) => void;
  onClearNotes: () => void;
  onBrowseAll: () => void;
}
export function StartPanel({
  mode,
  notes,
  topicsContent,
  pathwaysContent,
  audience,
  liveRead,
  activeTerms,
  suggestedTerms,
  detectedLevel,
  hasSearch,
  onReset,
  onModeChange,
  onNotesChange,
  onAudienceChange,
  onToggleTerm,
  onClearNotes,
  onBrowseAll
}: StartPanelProps) {
  const tabs: {
    id: EntryMode;
    label: string;
    icon: typeof Tags;
  }[] = [{
    id: 'topics',
    label: 'Browse Skill Modules',
    icon: Tags
  }, {
    id: 'pathways',
    label: 'Browse Pathways',
    icon: Library
  }, {
    id: 'notes',
    label: 'From Conversation Notes',
    icon: MessageSquareText
  }];
  return <div className="rounded-xl border border-gray-100 bg-white shadow-sm" data-id="element-2067" data-mp="2ilfjrpm6rjsv">
      <div className="flex flex-wrap border-b border-gray-200 px-5" data-id="element-2068" data-mp="2dlkwdw1mdcck">
        {tabs.map(tab => {
        const active = mode === tab.id;
        const Icon = tab.icon;
        return <button key={tab.id} type="button" onClick={() => onModeChange(tab.id)} aria-pressed={active} className={active ? 'flex items-center gap-2 border-b-2 border-[#00638C] pb-4 pt-4 pr-6 text-sm font-medium text-[#00638C] transition-colors' : 'flex items-center gap-2 border-b-2 border-transparent pb-4 pt-4 pr-6 text-sm font-medium text-gray-600 transition-colors hover:text-gray-900'} data-id="element-2069" data-mp="24kmnp0g8kgnn"><Icon size={16} data-id="element-2070" data-mp="1w9w1ivily6xv" />{tab.label}</button>;
      })}
      </div>
      <div className="p-5" data-id="element-2071" data-mp="213h4l1z25r3x">
        {mode === 'topics' ? topicsContent : mode === 'pathways' ? pathwaysContent : <NotesInput notes={notes} audience={audience} liveRead={liveRead} activeTerms={activeTerms} suggestedTerms={suggestedTerms} detectedLevel={detectedLevel} hasSearch={hasSearch} onReset={onReset} onNotesChange={onNotesChange} onAudienceChange={onAudienceChange} onToggleTerm={onToggleTerm} onClearNotes={onClearNotes} onBrowseAll={onBrowseAll} data-id="element-2072" data-mp="1ncvi73aeaz1a" />}
      </div>
    </div>;
}